import { useMutation } from '@tanstack/react-query'
import { assignTagsToPlayers } from '../services'
import { TagsMutationKeys } from '../../constants'
import type { AssignTagsToPlayersDto } from '../../types'

type UseMutationAssignTagsToPlayersParams = {
	payload: AssignTagsToPlayersDto
}

export default function useMutationAssignTagsToPlayers() {
	return useMutation({
		mutationKey: [TagsMutationKeys.AssignTagsToPlayers],
		mutationFn: ({ payload }: UseMutationAssignTagsToPlayersParams) =>
			assignTagsToPlayers(payload),
	})
}
